module.exports = __webpack_public_path__ + "img/icon-16-close.7e983d04.svg";